export const FALLBACK_COUNTRY_ALIASES = [
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "たいわん", ALIAS_TYPE: "hiragana" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "Taiwan", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "台灣", ALIAS_TYPE: "alias" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "台湾（中華民国）", ALIAS_TYPE: "alias" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "中華民国", ALIAS_TYPE: "alias" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "台北", ALIAS_TYPE: "city" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "たいぺい", ALIAS_TYPE: "city" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "Taipei", ALIAS_TYPE: "city" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "高雄", ALIAS_TYPE: "city" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "Kaohsiung", ALIAS_TYPE: "city" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "台中", ALIAS_TYPE: "city" },
  { COUNTRY_NMV: "台湾", ISO_CODE: "TW", ALIAS_NMV: "Taichung", ALIAS_TYPE: "city" },
  { COUNTRY_NMV: "アメリカ合衆国", ISO_CODE: "US", ALIAS_NMV: "あめりか", ALIAS_TYPE: "hiragana" },
  { COUNTRY_NMV: "アメリカ合衆国", ISO_CODE: "US", ALIAS_NMV: "アメリカ", ALIAS_TYPE: "alias" },
  { COUNTRY_NMV: "アメリカ合衆国", ISO_CODE: "US", ALIAS_NMV: "United States", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "アメリカ合衆国", ISO_CODE: "US", ALIAS_NMV: "USA", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "イギリス", ISO_CODE: "GB", ALIAS_NMV: "いぎりす", ALIAS_TYPE: "hiragana" },
  { COUNTRY_NMV: "イギリス", ISO_CODE: "GB", ALIAS_NMV: "英国", ALIAS_TYPE: "alias" },
  { COUNTRY_NMV: "イギリス", ISO_CODE: "GB", ALIAS_NMV: "United Kingdom", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "イギリス", ISO_CODE: "GB", ALIAS_NMV: "UK", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "大韓民国", ISO_CODE: "KR", ALIAS_NMV: "かんこく", ALIAS_TYPE: "hiragana" },
  { COUNTRY_NMV: "大韓民国", ISO_CODE: "KR", ALIAS_NMV: "韓国", ALIAS_TYPE: "alias" },
  { COUNTRY_NMV: "大韓民国", ISO_CODE: "KR", ALIAS_NMV: "Korea", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "大韓民国", ISO_CODE: "KR", ALIAS_NMV: "South Korea", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "中国", ISO_CODE: "CN", ALIAS_NMV: "ちゅうごく", ALIAS_TYPE: "hiragana" },
  { COUNTRY_NMV: "中国", ISO_CODE: "CN", ALIAS_NMV: "China", ALIAS_TYPE: "english" },
  { COUNTRY_NMV: "香港", ISO_CODE: "HK", ALIAS_NMV: "ほんこん", ALIAS_TYPE: "hiragana" },
  { COUNTRY_NMV: "香港", ISO_CODE: "HK", ALIAS_NMV: "Hong Kong", ALIAS_TYPE: "english" },
];

export const COUNTRY_ALIAS_TO_ISO_CODE = FALLBACK_COUNTRY_ALIASES.reduce(
  (map, alias) => {
    map[alias.ALIAS_NMV] = alias.ISO_CODE;
    map[String(alias.ALIAS_NMV).toLowerCase()] = alias.ISO_CODE;
    return map;
  },
  {},
);

export const normalizeCountryAliasText = (value) =>
  String(value || "")
    .normalize("NFKC")
    .trim()
    .toLowerCase()
    .replace(/[ぁ-ゖ]/g, (char) =>
      String.fromCharCode(char.charCodeAt(0) + 0x60),
    )
    .replace(/[\s・ー_\-.(),（）]/g, "");

export const getISOCodeFromAliasRows = (value, aliasRows = []) => {
  const input = normalizeCountryAliasText(value);
  if (!input) return null;

  const rows = [...FALLBACK_COUNTRY_ALIASES, ...aliasRows];
  const match = rows.find((alias) => {
    const aliasText = normalizeCountryAliasText(alias.ALIAS_NMV);
    const countryText = normalizeCountryAliasText(alias.COUNTRY_NMV);
    return (
      input === aliasText ||
      input === countryText ||
      input.includes(aliasText) ||
      input.includes(countryText)
    );
  });

  return match?.ISO_CODE || null;
};
